var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{attrs:{"border":"","resizable":"","auto-resize":"","highlight-hover-row":"","size":"mini","columns":_vm.tableColumns,"data":_vm.data,"row-class-name":_vm.rowClassName}})}
var staticRenderFns = []

export { render, staticRenderFns }